import {Ripple, Scroll, Resize} from 'vuetify/es5/directives'
import {
  transitions,
  VAlert,
  VApp,
  VAutocomplete,
  VBtn,
  VBtnToggle,
  VCard,
  VCarousel,
  VCheckbox,
  VChip,
  VDialog,
  VDivider,
  VExpansionPanel,
  VFooter,
  VForm,
  VGrid,
  VIcon,
  VList,
  VMenu,
  VNavigationDrawer,
  VPagination,
  VRating,
  VStepper,
  VTextarea,
  VTextField,
  VSnackbar,
  VOverflowBtn,
  VRadioGroup,
  VAvatar,
  VSlider,
  VDataTable,
  VToolbar,
  VItemGroup,
  VSelect,
  VTooltip,
  VDatePicker,
  VBadge,
  VTabs,
  VImg,
  VProgressCircular,
  VProgressLinear,
  VWindow
} from 'vuetify'

// The components
export const APP_COMPONENTS = {
  VApp,
  VNavigationDrawer,
  VFooter,
  VList,
  VBtn,
  VAlert,
  VCard,
  VDialog,
  VBtnToggle,
  VStepper,
  VForm,
  VIcon,
  VGrid,
  VDivider,
  VToolbar,
  VCheckbox,
  VTextField,
  VExpansionPanel,
  VTextarea,
  VPagination,
  VCarousel,
  VChip,
  VRating,
  VMenu,
  VAutocomplete,
  VSnackbar,
  VOverflowBtn,
  VRadioGroup,
  VAvatar,
  VSlider,
  VDataTable,
  VWindow,
  VItemGroup,
  VSelect,
  VTooltip,
  VDatePicker,
  VBadge,
  VTabs,
  VImg,
  VProgressCircular,
  VProgressLinear,
  transitions
}
// Directives
export const APP_DERECTIVES = {
  Ripple, Scroll, Resize
}
// Icons
export const APP_ICONS = {
  next: 'a-icon a-icon__dropdown next',
  prev: 'a-icon a-icon__dropdown prev',
  dropdown: 'a-icon a-icon__dropdown',
  expand: 'a-icon a-icon__dropdown',
  checkboxOff: 'a-icon a-icon__checkbox a-icon__checkbox-off',
  checkboxOn: 'a-icon a-icon__checkbox a-icon__checkbox-on',
  radioOff: 'a-icon a-icon__radio a-icon__radio-off',
  radioOn: 'a-icon a-icon__radio a-icon__radio-on'
}
// The theme
export const APP_THEME = {
  primary: '#4d4dff',
  accent: '#2828d0',
  blueMedium: '#83d0f5',
  blueLight: '#d6f4fd',
  secondary: '#545454',
  grey1: '#9b9b9b',
  pink1: '#fde7e5',
  success: '#039e8b',
  error: '#f56225',
  warning: '#ffc250',
  sand: '#f6f4eb'
}



// WEBPACK FOOTER //
// ./src/config/vuetify.js